export default 'USER_OPENED_NEW_RECORDING_CONFIG';
